module.exports = "/_next/static/videos/4-e82e0d96db31416e7ba0da28b5cc7b08.webm";